function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-53"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M433.77,113.03c-1.54-2.56-3.13-5.07-4.8-7.52-22.23-32.66-59.23-55.02-95.19-65.15-15.75-4.44-31.93-6.77-48.08-7.36-105.91-3.85-144.82,83.48-178.94,105.99-34.12,22.52-86.49,60.97-79.92,141.76,4.99,61.42,39.93,120.16,103.75,146.89,7.03,2.95,14.42,5.52,22.15,7.64,14.38,3.96,29.98,6.44,46.77,7.19,48.25,2.15,87.43-9.48,125.75-38.77,8.91-6.81,17.77-14.49,29.33-15.33,8.4-.61,16.37,2.41,7.59,10.53-10.32,9.54,1.59,28.32,27.79,15.27,43.77-21.78,61.77-68.78,70.25-116.57,10.41-58.66,5.36-131.61-26.45-184.58Z",
    style: {
      fill: "#00040F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.77,113.03c-1.54-2.56-3.13-5.07-4.8-7.52-22.23-32.66-59.23-55.02-95.19-65.15-15.75-4.44-31.93-6.77-48.08-7.36-105.91-3.85-144.82,83.48-178.94,105.99-34.12,22.52-86.49,60.97-79.92,141.76,4.99,61.42,39.93,120.16,103.75,146.89,7.03,2.95,14.42,5.52,22.15,7.64,14.38,3.96,29.98,6.44,46.77,7.19,48.25,2.15,87.43-9.48,125.75-38.77,8.91-6.81,17.77-14.49,29.33-15.33,8.4-.61,16.37,2.41,7.59,10.53-10.32,9.54,1.59,28.32,27.79,15.27,43.77-21.78,61.77-68.78,70.25-116.57,10.41-58.66,5.36-131.61-26.45-184.58Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-53"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 472.09,
    y1: 461.34,
    x2: 24.09,
    y2: 461.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-53"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 249.06,
    y: 61.31,
    width: 150.5,
    height: 207.17,
    style: {
      fill: "#263238",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.23,
    y: 70.55,
    width: 136.17,
    height: 188.68,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 338.67,
    y1: 99.76,
    x2: 305.09,
    y2: 133.34,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 356.2,
    y1: 82.22,
    x2: 342.03,
    y2: 96.4,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.91,
    y1: 110.58,
    x2: 295.76,
    y2: 130.73,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 311.06,
    y1: 243.04,
    x2: 305.09,
    y2: 249.01,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 356.2,
    y1: 197.89,
    x2: 314.41,
    y2: 239.68,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.91,
    y1: 226.25,
    x2: 295.76,
    y2: 246.39,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.3,172.62c0-2.51-2.03-4.54-4.54-4.54s-4.54,2.03-4.54,4.54,2.03,4.54,4.54,4.54,4.54-2.03,4.54-4.54Z",
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.23,
    y: 171.97,
    width: 136.17,
    height: 8.35,
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.52,
    y: 48.91,
    width: 158.47,
    height: 17.71,
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.52,
    y: 262.28,
    width: 158.47,
    height: 17.71,
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 188.86,
    y: 24.12,
    width: 270.91,
    height: 5.31,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.6,
    y: 19.7,
    width: 15.05,
    height: 279.76,
    rx: 4.49,
    ry: 4.49,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.77,
    y: 19.7,
    width: 15.05,
    height: 279.76,
    rx: 4.49,
    ry: 4.49,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.93,
    y: 19.7,
    width: 15.05,
    height: 279.76,
    rx: 4.49,
    ry: 4.49,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.1,
    y: 19.7,
    width: 15.05,
    height: 279.76,
    rx: 4.49,
    ry: 4.49,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.37,
    y: 19.7,
    width: 15.05,
    height: 279.76,
    rx: 4.49,
    ry: 4.49,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.54,
    y: 19.7,
    width: 15.05,
    height: 279.76,
    rx: 4.49,
    ry: 4.49,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.7,
    y: 19.7,
    width: 15.05,
    height: 279.76,
    rx: 4.49,
    ry: 4.49,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.87,
    y: 19.7,
    width: 15.05,
    height: 279.76,
    rx: 4.49,
    ry: 4.49,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-53"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.38,
    y: 18.87,
    width: 119.4,
    height: 158.95,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.28,
    y: 24.06,
    width: 111.61,
    height: 148.58,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.27,133.17c12.51-6.48,39.56-23.75,46.95-54.88,5.84-24.59,14.3-42.55,27.22-54.23",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.58,172.64c-7.71-25.02-17.39-73.56,9.63-105.79,17.05-20.34,34.11-32.06,47.69-38.8",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.69,24.06c5.19,6.47,10.81,17.67,9.03,34.82-1.9,18.37-10.23,28.75-16.45,34.08",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.39,172.64c-8.73-13.29-22.42-11.29-31.76-23.65-11.78-15.59-.35-38.81,26.68-49.57,8.45-3.36,14.4-8.21,18.58-13.29",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.27,163.13c8.19-12.5,18.46-24.3,24.76-17.25,5.25,5.87,6.51,16.64,6.29,26.77",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.54,24.06c.28,14.47,2.03,41.32,11.05,29.97,6.29-7.9,11.27-20.07,14.61-29.97",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.89,45.09c-14.67,12.65-40.17,36.17-23.08,32.85,9.1-1.77,16.93-7.37,23.08-13.54",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-53"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.47,296.3s-9.7-2.24-11.94-12.68c-2.24-10.44,4.97-5.97-1.49-22.38-6.47-16.41-4.97-20.14-2.74-24.87,2.24-4.72,3.48-3.23,5.47,2.98,1.99,6.22,9.2,15.92,11.94,34.07,2.74,18.15-1.24,22.88-1.24,22.88Z",
    style: {
      fill: "#00040F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.62,278.64s-6.47-2.24-6.71-14.42c-.25-12.19,4.73-9.7,5.47-24.87s1.74-25.86,4.48-26.11c2.74-.25,9.95,7.46,12.43,24.37,2.49,16.91-3.23,28.1-8.21,33.08-4.97,4.97-7.46,7.96-7.46,7.96Z",
    style: {
      fill: "#00040F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.99,310.97s-1.49-8.95-4.48-13.18c-2.98-4.23-9.45-7.96-13.68-16.16-4.23-8.21-8.95-12.19-8.7-.5,.25,11.69,5.47,17.66,11.94,21.64,6.47,3.98,14.92,8.21,14.92,8.21Z",
    style: {
      fill: "#00040F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.26,326.39s-5.97-11.44-14.67-19.9c-8.7-8.46-15.67-12.68-13.18-8.46,2.49,4.23,5.47,3.98,9.7,11.44,4.23,7.46,2.98,12.93,8.95,17.16,5.97,4.23,9.2-.25,9.2-.25Z",
    style: {
      fill: "#00040F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.51,341.06c-.25-.75-.5-6.22-8.95-10.69-8.46-4.48-16.41-2.74-15.42-.5,.99,2.24,6.22,5.97,11.44,8.21,5.22,2.24,12.93,2.98,12.93,2.98Z",
    style: {
      fill: "#00040F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.13,311.47s-3.73-4.73-1.74-14.67c1.99-9.95,6.47-7.46,11.44-12.68,4.97-5.22,3.98-5.97,8.95-11.44,4.97-5.47,9.45-8.46,11.44-6.22,1.99,2.24-.99,9.2-3.98,13.18-2.98,3.98-7.71,5.97-9.95,10.94-2.24,4.97-1.24,12.93-6.96,16.66-5.72,3.73-9.2,4.23-9.2,4.23Z",
    style: {
      fill: "#00040F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.56,314.21s8.95-10.2,15.42-17.66c6.47-7.46,8.95-13.18,9.2-8.21,.25,4.97,2.24,8.95-2.98,15.42-5.22,6.47-21.64,10.44-21.64,10.44Z",
    style: {
      fill: "#00040F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.83,330.62s-.25-3.98,13.93-13.18c14.18-9.2,20.14-10.94,18.65-7.21-1.49,3.73-7.71,7.46-14.42,14.18-6.71,6.71-18.15,6.22-18.15,6.22Z",
    style: {
      fill: "#00040F"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.26,279.26c.12-.06,.23-.15,.27-.28,.02-.06,.57-1.83,1.39-4.59,.18-.48,.35-.96,.54-1.43h0c.02-.05,0-.1-.05-.12-.01,0-.02,0-.03,0,1.95-6.69,4.93-17.44,6.21-24.95,1.8-10.6,.17-18.72-.91-24.1-.12-.6-.23-1.16-.33-1.69-.05-.27-.31-.45-.59-.4-.27,.05-.45,.31-.4,.59,.1,.53,.21,1.1,.34,1.7,1.07,5.31,2.68,13.33,.91,23.74-1.96,11.52-7.96,30.77-8.02,30.96-.07,.23,.04,.47,.24,.58-1.56,4.48-2.82,9.06-3.93,13.67-1.58,6.85-2.73,13.79-3.53,20.78l-.5,5.25c-.08,.88-.17,1.75-.24,2.63l-.14,2.63c-.08,1.76-.18,3.51-.23,5.27l.05,5.28,.06,2.64c.04,.88,.1,1.76,.16,2.63,.13,1.75,.24,3.51,.4,5.26,.34,3.5,.86,6.98,1.4,10.44,0,.04,.05,.08,.09,.08,.05,0,.09-.04,.09-.09h0c0-1.76-.08-3.51-.12-5.26-.05-1.75-.2-3.49-.18-5.24,0-1.75-.04-3.49-.06-5.24l-.05-2.62,.05-2.62,.02-5.23,.14-5.23,.05-2.62c.03-.87,.1-1.74,.15-2.61l.32-5.22c.61-6.95,1.57-13.88,2.96-20.72,.95-4.66,2.05-9.31,3.47-13.86Z",
    style: {
      fill: "#858585"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.23,309.9c-3.79,2.4-7.18,5.43-10.14,8.84-1.45,1.73-2.81,3.54-3.96,5.51l-.81,1.54-.64,1.6c-.23,.53-.39,1.07-.56,1.62-.16,.54-.35,1.09-.49,1.64-1.14,4.39-1.89,8.87-2.1,13.37-.18,4.5-.1,9,.5,13.47,0,.04,.04,.08,.09,.08,.05,0,.1-.03,.1-.09l1.16-13.33c.46-4.41,.74-8.84,1.69-13.15,.12-.54,.27-1.06,.41-1.59,.14-.53,.27-1.06,.47-1.57l.54-1.54,.7-1.46c1.03-1.93,2.28-3.77,3.63-5.51,2.71-3.49,5.89-6.68,9.52-9.26h0s.05-.09,.02-.13c-.03-.04-.08-.06-.13-.03Z",
    style: {
      fill: "#858585"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.02,327.06c-2.07,1.33-3.45,3.43-4.61,5.54-1.11,2.16-1.98,4.44-2.58,6.79-.18,.58-.32,1.17-.45,1.76l-.42,1.77c-.21,1.19-.38,2.39-.45,3.6-.02,1.21-.05,2.42,.03,3.62,.1,1.21,.24,2.41,.47,3.6,0,.03,.04,.07,.07,.07,.05,.01,.1-.02,.11-.07,.29-1.19,.48-2.37,.64-3.54,.19-1.17,.37-2.34,.51-3.51,.17-1.16,.33-2.32,.42-3.49,.16-1.16,.25-2.34,.5-3.48,.41-2.31,1.07-4.57,1.98-6.73,.9-2.14,2.07-4.27,3.87-5.78h.01s.04-.09,.02-.13c-.03-.04-.08-.05-.13-.03Z",
    style: {
      fill: "#858585"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.76,340.41c-.5-5.92-1.47-11.78-2.4-17.64-.93-5.86-1.95-11.7-3.02-17.53-.62-3.23-1.25-6.46-1.91-9.69,.1-.11,.15-.26,.12-.42-.03-.18-3.37-18.01-6.82-30.56-3.44-12.54-5.7-20.32-5.72-20.4-.08-.27-.35-.42-.62-.34-.27,.08-.42,.35-.34,.62,.02,.08,2.28,7.85,5.72,20.39,3.44,12.52,6.77,30.31,6.8,30.48,.04,.2,.18,.34,.37,.39,.52,3.23,1.01,6.46,1.49,9.69,.89,5.85,1.72,11.71,2.47,17.58,.72,5.87,1.29,11.76,2.02,17.62l2.17,17.62s.04,.08,.09,.08c.05,0,.09-.04,.1-.09,.07-1.48,.07-2.97,.11-4.46,.01-1.49-.06-2.97-.09-4.46-.05-2.97-.31-5.93-.53-8.89Z",
    style: {
      fill: "#858585"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.21,340.33c-.32-2.34-.75-4.68-1.19-7l-.83-3.46c-.27-1.15-.53-2.31-.87-3.44-1.18-4.59-2.69-9.09-4.52-13.46l-.71-1.63-.38-.77c0-.08-.02-.15-.06-.22,0-.01-.13-.23-.34-.59h0c-.5-1.09-1.11-2.11-1.68-3.14-1.17-1.9-2.39-3.8-4-5.38-.98-1.31-2.04-2.67-3.18-4.02-1.41-1.67-2.71-3.1-3.97-4.5-3.53-3.91-6.32-6.99-8.14-11.53-.1-.26-.4-.38-.65-.28-.26,.1-.38,.39-.28,.65,1.88,4.71,4.72,7.85,8.32,11.83,1.25,1.39,2.55,2.82,3.95,4.47,5.38,6.35,9.07,12.91,9.11,12.98,.06,.11,.17,.18,.28,.21l.27,.61,.62,1.64c1.64,4.38,2.95,8.89,3.94,13.46,.54,2.28,.9,4.6,1.34,6.89l.55,3.47c.2,1.15,.45,2.3,.61,3.46,.37,2.31,.79,4.62,1.2,6.94,.36,2.32,.78,4.64,1.27,6.96,0,.04,.05,.08,.09,.08,.05,0,.09-.04,.09-.09,.01-2.36-.04-4.73-.17-7.09-.14-2.36-.42-4.71-.66-7.06Z",
    style: {
      fill: "#858585"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.31,340.63c-1.1-3.11-2.37-6.15-3.75-9.13-1.42-2.96-2.95-5.87-4.71-8.64-.03-.04-.08-.05-.12-.03-.04,.03-.06,.08-.03,.13,1.54,2.88,2.84,5.88,4.02,8.91,1.2,3.03,2.28,6.1,3.19,9.22,.93,3.12,1.59,6.3,2.42,9.43,.87,3.13,1.58,6.29,2.54,9.46,.01,.04,.05,.07,.09,.07,.05,0,.09-.04,.09-.09,.05-3.31-.28-6.61-.92-9.85-.58-3.26-1.73-6.37-2.82-9.48Z",
    style: {
      fill: "#858585"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.11,350.97c-.56-1.94-1.52-3.76-2.61-5.46-1.07-1.72-2.31-3.34-3.79-4.71-.16-.14-.32-.27-.48-.4,0,0-.02-.02-.03-.03h-.02c-.6-.51-1.21-.99-1.88-1.39-.54-.34-1.1-.63-1.69-.88-2.99-1.86-7.31-4.45-10.8-6.19-.25-.12-.55-.02-.67,.22-.12,.25-.02,.55,.22,.67,5.87,2.94,14.2,8.35,14.29,8.4,.08,.05,.16,.07,.24,.07,.05,.06,.11,.11,.15,.16,1.28,1.43,2.31,3.08,3.16,4.79,.9,1.7,1.36,3.58,2.14,5.33,.34,.9,.69,1.8,1.09,2.7,.34,.92,.71,1.83,1.19,2.73h0s.05,.05,.08,.06c.05,0,.1-.04,.1-.09,.04-1.01-.02-2.02-.11-3.03-.15-.99-.36-1.98-.59-2.96Z",
    style: {
      fill: "#858585"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,270.75c-.24-.14-.54-.07-.69,.17-2.26,3.77-6.63,8.81-10.84,13.68-2.67,3.08-5.19,5.99-7.03,8.41-4.75,6.24-6.73,17.88-6.81,18.38-.02,.14,.01,.27,.09,.37-.14,.59-.29,1.18-.42,1.77-.97,4.5-1.73,9.06-2.2,13.65-.46,4.58-.98,9.16-1.04,13.76-.07,4.6,0,9.2,.49,13.8,0,.04,.04,.08,.08,.08,.05,0,.1-.03,.1-.08,.53-4.58,.86-9.15,1.17-13.72,.32-4.57,.37-9.15,.67-13.72,.28-4.55,.85-9.09,1.63-13.6,.12-.68,.25-1.36,.37-2.04,.02-.04,.03-.07,.04-.12,.02-.12,2.02-11.89,6.62-17.93,1.82-2.4,4.33-5.29,6.99-8.36,4.25-4.9,8.64-9.97,10.95-13.82,.14-.24,.07-.54-.17-.69Z",
    style: {
      fill: "#858585"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.84,390.92c-.56-15.09-17.33-25.15-17.33-25.15h-25.7s-16.77,10.06-17.33,25.15c-.56,15.09,19,70.42,19,70.42h22.34s19.56-55.33,19-70.42Z",
    style: {
      fill: "#858585"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.82 350.93 60.03 350.93 63.82 365.77 89.04 365.77 92.82 350.93",
    style: {
      fill: "#858585"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-53"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M268.47,413.55s-35.25,10.01-40.25,10.88c-5,.87-6.96-.44-11.97,1.52-5,1.96-15.01,4.13-15.01,4.13,0,0-23.06,4.13-35.03,3.7s-16.32-1.96-16.32-1.96l-3.92-1.09s-1.96,3.92-2.18,7.18c-.22,3.26,1.09,19.58,1.09,19.58,0,0,5.22-1.52,18.06,1.09s32.42,6.09,47,3.7c14.58-2.39,15.67-4.35,20.89-5,5.22-.65,23.06,4.57,27.2,4.35,4.13-.22,101.83,0,101.83,0,0,0,10.01-4.13,18.5-10.44s23.72-10.44,28.5-21.76c4.79-11.31-7.18-23.28-13.49-24.15-6.31-.87-37.64,10.44-38.95,10.66-1.31,.22-5.26-3.45-5.26-3.45l-80.69,1.06Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.1,
    y1: 421.24,
    x2: 295.1,
    y2: 428.16,
    style: {
      fill: "none",
      stroke: "#949494",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.26,421.24s10.84,10.15,13.15,14.99",
    style: {
      fill: "none",
      stroke: "#949494",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.32,421.47s-7.38,5.77-10.61,10.84",
    style: {
      fill: "none",
      stroke: "#949494",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.63,422.39s-5.77,7.61-7.61,11.76",
    style: {
      fill: "none",
      stroke: "#949494",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M261.77,326.77s-9.1,6.94-15.8,12.21c-6.7,5.27-13.89,11.01-21.55,14.37-7.66,3.35-29.93,3.59-45.73,9.58-15.8,5.99-34.72,9.58-34.72,9.58l1.92,14.13s65.12-3.11,78.53-6.46c13.41-3.35,13.65-5.75,20.11-2.63s27.3,32.56,27.3,32.56l-5.75,1.2,.48,3.59s11.49,5.51,29.93,4.31c18.44-1.2,32.32-2.15,36.39-2.39,4.07-.24,16.28-4.31,16.28-4.31,0,0-2.63-14.37-8.38-37.11-5.75-22.75-5.51-36.39-5.51-36.39l31.6,12.45s.96,11.73-1.2,28.49c-2.15,16.76-4.55,23.7-4.55,23.7l16.28,5.27s8.62-41.66,11.49-53.63c2.87-11.97-1.92-17.48-5.27-20.35-3.35-2.87-44.29-27.77-54.11-30.65-9.82-2.87-22.27-3.11-27.77-1.44-5.51,1.68-19.39,7.18-19.39,7.18l-20.59,16.76Z",
    style: {
      fill: "#00040F",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.96,413.19c2.75,.62,6.26,1.07,10.65,1.07,13.97,0,16-.76,16-.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.57,409.69s1.34,1.21,4.55,2.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.09,414.5c1.58-.44,3.09-.94,4.5-1.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.98,417.31s16.75,1.01,30.77-1.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M236.08,372.27c-3.42-3.2-9.45-8.45-14.29-10.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.78,374.9s-.42-.43-1.14-1.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.6,361.97s6.7,4.79,8.38,6.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.4,338.03s-6.7-1.2-9.82-6.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.57,351.59c8.16,2.54,16.63,4.74,22.42,5.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.83,342.82s9.61,3.85,20.76,7.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.72,375.35c2.48,1.05,4.76,1.88,6.74,2.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.22,350.24s23.63,15.49,40.91,23.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.15,360.03c1.81,1.31,3.18,2.28,3.46,2.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.77,351.68s4.35,3.23,8.35,6.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.39,324.08c-.13,.99-.33,1.98-.62,2.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.05,311.45s1.55,4.65,1.52,9.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M234.01,281.99s.57,11.62,.96,14.16c.39,2.53-2.75,11.45,2.94,20.33,3.22,5.04,2.53,12.67,6.24,13.64,3.7,.97,13.05-2.92,13.05-2.92,0,0,2.73,5.07,4.09,8.38,1.36,3.31,9.35,11.89,17.93,6.43,8.57-5.46,11.69-22.99,10.72-26.5-.97-3.51-2.73-5.65-3.7-6.43s-3.31-3.12-3.9-4.68c-.58-1.56-1.36-5.26-.97-8.57s1.75-16.37-1.17-21.04c-2.92-4.68-8.77-8.57-19.68-8.57s-20.26,4.09-20.26,4.09c0,0,2.14-3.7,.39-2.92s-3.31,2.92-3.31,2.92c0,0-.39-5.46-2.34-2.34-1.95,3.12-1.75,6.82-1.75,6.82,0,0-1.36-1.56-1.56,.78-.19,2.34,2.34,6.43,2.34,6.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.36,295.82c.39-3.31,1.75-16.37-1.17-21.04-2.92-4.68-8.77-8.57-19.68-8.57s-20.26,4.09-20.26,4.09c0,0,2.14-3.7,.39-2.92-1.75,.78-3.31,2.92-3.31,2.92,0,0-.39-5.46-2.34-2.34-1.95,3.12-1.75,6.82-1.75,6.82,0,0-1.36-1.56-1.56,.78-.19,2.34,2.34,6.43,2.34,6.43,0,0,2.73,1.56,4.29,.97,1.56-.58,4-2.15,5.46-2.53,5.18-1.35,14.22-1.75,12.28,.97s-5.07,4.09-2.73,5.65c2.34,1.56,9.35,2.92,9.74,5.07,.39,2.14,.19,6.43,2.34,5.26,2.14-1.17,3.12-5.07,6.43-4.09,3.31,.97,6.04,5.26,4.87,8.57-1.17,3.31,.39,4.09,3.31,1.75,.61-.49,1.16-1.1,1.67-1.77-.33-1.75-.54-3.96-.3-6.02Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.93,296.61s3.49-5.07,6.02-5.07,5.65,3.31,2.73,10.33c-2.92,7.01-6.82,7.79-7.79,3.12",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M238.64,295.38l1.29,3.24s-1.29,10.35-.43,12.08,6.47,.65,6.47,.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.45,316.52s6.47,2.16,12.08-4.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.25,292.8s6.26-2.59,9.71-.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238,
    y1: 293.87,
    x2: 235.84,
    y2: 292.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29,297.86c0,1.13-.58,2.05-1.29,2.05s-1.29-.92-1.29-2.05,.58-2.05,1.29-2.05,1.29,.92,1.29,2.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.02,298.6c0,1.06-.52,1.92-1.16,1.92s-1.16-.86-1.16-1.92,.52-1.92,1.16-1.92,1.16,.86,1.16,1.92Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.2,327.19s8.22-1.75,9.59-3.35c1.37-1.6,.69,2.06-.23,7.55-.92,5.49-2.75,7.1-2.75,7.1,0,0-1.6-1.37-2.98-4.81-1.37-3.43-3.64-6.49-3.64-6.49Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.79,390.79s-5.82,8.91-5.64,19.64c.18,10.73,5.45,40.36,7.82,46.36,2.36,6,6.73,11.45,13.27,8,6.54-3.45,11.27-3.82,14.54-4s7.45-.91,7.82-8.18c.36-7.27-1.82-14.73-1.82-14.73,0,0,3.45-6.73,2.55-10-.91-3.27-10-5.27-11.64-7.27-1.64-2-6-16.18-7.45-20-1.45-3.82-1.64-6.91-1.27-9.82,.36-2.91,2.36-10-3.82-8.73-6.18,1.27-9.64,5.09-14.36,8.73Z",
    style: {
      fill: "#00040F",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.51,419.73s1.8-.8,3.2-.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.91,415.53s1.8-1.2,2.8-1.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.31,
    y1: 410.53,
    x2: 131.91,
    y2: 409.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.6,444.42c-3.64-9.27-7.82-27.09-7.82-41.82s2.65-17.68,4-20.67c-.47-.03-1,0-1.63,.12-6.18,1.27-9.64,5.09-14.36,8.73,0,0-5.82,8.91-5.64,19.64,.18,10.73,5.45,40.36,7.82,46.36,2.36,6,6.73,11.45,13.27,8,2.58-1.36,4.88-2.24,6.91-2.82,.13-3.97-.07-11.22-2.55-17.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.24,447.51c-3.09-9.64-4.73-23.82-5.27-39.82-.43-12.49,3.91-21.99,5.84-25.55-5.96,1.34-9.38,5.08-14.02,8.64,0,0-5.82,8.91-5.64,19.64,.18,10.73,5.45,40.36,7.82,46.36,2.36,6,6.73,11.45,13.27,8,.03-.02,.06-.03,.09-.05,.4-3.18,.28-9.82-2.09-17.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M361.13,403.63s-14.18,.44-15.12,1.07-12.3,6.31-13.88,7.26c-1.58,.95-4.42,5.36-3.63,6.31,.79,.95,2.52,.63,3.63,.32,1.1-.32,3.94-.79,3.94-.79,0,0-2.21,1.89-1.26,2.05,.95,.16,5.21-1.1,6.31-1.74,1.1-.63,12.15-3.31,13.41-3.31s10.1,1.26,15.46-.63c5.36-1.89,7.43-5.27,7.43-5.27l-16.28-5.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M336.07,417.79s12.64-6.32,13.64-6.73c1.01-.4,3.62-1.21,3.62-1.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.5,418.27s9.34-5.39,10.35-5.79c1.01-.4,10.06-4.83,10.06-4.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.99,414.41s4.95-2.92,5.62-3.22c.67-.3,10.5-5.02,10.5-5.02",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M303.42,440.98s-7.26-4.26-12.15-5.36c-4.89-1.1-10.1,1.58-13.72,1.58s-12.46-3.79-19.24-3.94c-6.78-.16-14.67,8.05-13.72,14.2,.95,6.15,3.47,10.88,10.57,12.78,7.1,1.89,36.75,1.42,36.75,1.42l13.57-.79s-1.42-8.52-1.42-11.99-.63-7.89-.63-7.89Z",
    style: {
      fill: "#00040F",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61,444.51s-3.8,4-1.8,11.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.21,445.11s-3.8,4-1.8,11.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.8,445.71s-3.8,4-1.8,11.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.4,446.31s-3.8,4-1.8,11.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.15,460.23c.11,.03,.24,.06,.36,.08-1.85-1.1-4.19-2.77-5.09-4.66-1.58-3.31-2.05-4.42-1.1-6.31,.95-1.89,1.74-3,1.74-5.84s.16-4.89,.16-4.89c0,0,3.94-3.94,6.94-4.1,2.36-.12,10.97,1.32,16.15,2.16-4.34-1.04-10.77-3.3-15.99-3.43-6.78-.16-14.67,8.05-13.72,14.2s3.47,10.88,10.57,12.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M387.18,409.75s-21.45,5.99-33.28,11.52c-11.83,5.52-32.5,17.67-32.5,17.67l-17.98,2.05s0,13.72,.16,15.46c.16,1.74,1.89,4.42,1.89,4.42,0,0,31.86-2.84,45.43-5.05,13.57-2.21,40.23-12.62,46.69-16.88",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.4,441.81s14.88-1.79,36.74-14.7c11.4-6.73,19.19-8.56,25.09-10.04",
    style: {
      fill: "none",
      stroke: "#949494",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.27,435.62c-4.89-1.1-10.1,1.58-13.72,1.58,3.31,.47,8.83,.63,12.46-.47,.84-.26,1.74-.5,2.63-.73-.47-.14-.93-.27-1.36-.37Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M146.88,374.79s-2-2.18-5.09-2.73c-3.09-.55-14.36-3.27-16.54-2.73-2.18,.55-10.91,9.09-12.18,11.27-1.27,2.18-4.18,12-3.82,13.27,.36,1.27-.55,1.82,2.91-.36,3.45-2.18,5.09-5.09,7.82-7.82,2.73-2.73,4.18-3.64,4.18-3.64,0,0,4-.91,4.73-.91s3.83-1.49,2.19,2.33-6.01,8.76-5.1,11.13c.91,2.36,1.09,1.09,3.82-1.09s5.09-3.27,5.09-3.27c0,0,4.91-1.27,6.18-2,1.27-.73,5.64,.36,6.73-6.18,1.09-6.55-.91-7.27-.91-7.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.15,393.52s-.73-2.01,.96-4.54c1.69-2.54,8.66-10.99,9.72-11.83,1.06-.85,2.96-1.69,2.96-1.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.24,393.88s2.17-6.6,3.86-9.56c1.69-2.96,5.92-7.18,6.13-8.03,.21-.85,2.75-2.54,2.75-2.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopular);
export default __webpack_public_path__ + "static/media/popular.70638f70d25e29a731e62a1446352457.svg";
export { ForwardRef as ReactComponent };